export default __webpack_public_path__ + "static/media/feintattack4.54513438.png";